// extracted by mini-css-extract-plugin
module.exports = {"comp":"SectionF_comp__cgthG"};